<template>
  <div
    v-if="isVisible"
    class="modal-special-conditions"
    @click.self="emitClosed()"
  >
    <div class="modal-special-conditions__modal">
      <!-- heading -->
      <div class="modal-special-conditions__heading">
        <p class="modal-special-conditions__label">こだわり条件を選択してください</p>     
        <button
          class="modal-special-conditions__button --close"
          @click="emitClosed()"
        ></button>
      </div>
      <!-- body -->
      <div class="modal-special-conditions__body">
        <!-- 施設タイプ -->
        <div class="modal-special-conditions__heading --small">施設タイプ</div>
        <ul class="modal-special-conditions__list">
          <li
            v-for="item in selectedFacility"
            :key="`facility-${item.id}`"
            class="modal-special-conditions__item"
          >
            <AppCheckbox
              :label="item.label"
              :isChecked="item.checked"
              :isTop="true"
              :setPadding="true"
              class="modal-special-conditions__checkbox"
              @clicked="setList(item, 'selectedFacility')"
            />
          </li>
        </ul>
        <!-- 部屋タイプ -->
        <div class="modal-special-conditions__heading --small">部屋タイプ</div>
        <ul class="modal-special-conditions__list">
          <li
            v-for="item in selectedRoomType"
            :key="`roomType-${item.id}`"
            class="modal-special-conditions__item"
          >
            <AppCheckbox
              :label="item.label"
              :isChecked="item.checked"
              :isTop="true"
              :setPadding="true"
              class="modal-special-conditions__checkbox"
              @clicked="setList(item, 'selectedRoomType')"
            />
          </li>
        </ul>
        <!-- 食事条件 -->
        <div class="modal-special-conditions__heading --small">食事条件</div>
        <ul class="modal-special-conditions__list">
          <li
            v-for="item in selectedMealCondition"
            :key="`mealCondition-${item.id}`"
            class="modal-special-conditions__item"
          >
            <AppCheckbox
              :label="item.label"
              :isChecked="item.checked"
              :isTop="true"
              :setPadding="true"
              class="modal-special-conditions__checkbox"
              @clicked="setList(item, 'selectedMealCondition')"
            />
          </li>
        </ul>
        <!-- 部屋のこだわり -->
        <div class="modal-special-conditions__heading --small">部屋のこだわり</div>
        <ul class="modal-special-conditions__list">
          <li
            v-for="item in selectedRoomCondition"
            :key="`roomCondition-${item.id}`"
            class="modal-special-conditions__item"
          >
            <AppCheckbox
              :label="item.label"
              :isChecked="item.checked"
              :isTop="true"
              :setPadding="true"
              class="modal-special-conditions__checkbox"
              @clicked="setList(item, 'selectedRoomCondition')"
            />
          </li>
        </ul>
        <!-- 設備・サービス -->
        <div class="modal-special-conditions__heading --small">設備・サービス</div>
        <ul class="modal-special-conditions__list">
          <li
            v-for="item in selectedServiceEquip"
            :key="`serviceEquip-${item.id}`"
            class="modal-special-conditions__item"
          >
            <AppCheckbox
              :label="item.label"
              :isChecked="item.checked"
              :isTop="true"
              :setPadding="true"
              class="modal-special-conditions__checkbox"
              @clicked="setList(item, 'selectedServiceEquip')"
            />
          </li>
        </ul>
        <!-- 利用方法 -->
        <div class="modal-special-conditions__heading --small">利用方法</div>
        <ul class="modal-special-conditions__list">
          <li
            v-for="item in selectedUsageMethod"
            :key="`usageMethod-${item.id}`"
            class="modal-special-conditions__item"
          >
            <AppCheckbox
              :label="item.label"
              :isChecked="item.checked"
              :isTop="true"
              :setPadding="true"
              class="modal-special-conditions__checkbox"
              @clicked="setList(item, 'selectedUsageMethod')"
            />
          </li>
        </ul>
        <!-- 提供会社 -->
        <div class="modal-special-conditions__heading --small">提供会社</div>
        <ul class="modal-special-conditions__list">
          <li
            v-for="item in filteredSelectedPlanByCompany"
            :key="`planByCompany-${item.id}`"
            class="modal-special-conditions__item"
          >
            <AppCheckbox
              :label="item.label"
              :isChecked="item.checked"
              :isTop="true"
              :setPadding="true"
              class="modal-special-conditions__checkbox"
              @clicked="setList(item, 'selectedPlanByCompany')"
            />
          </li>
        </ul>
      </div>
      <!-- buttons -->
      <div class="modal-special-conditions__buttons">
        <button
          class="modal-special-conditions__button --reset"
          @click="resetList()"
        >リセット</button>
        <button
          class="modal-special-conditions__button --dicision"
          @click="emitInputed()"
        >決定</button>
      </div>
    </div>
  </div>
</template>

<script>
import AppCheckbox from '@/components/elements/AppCheckbox'

export default {
  components: {
    AppCheckbox
  },
  props: {
    facility: {
      type: Array,
      required: false,
      default: () => []
    }, // 施設タイプ
    roomType: {
      type: Array,
      required: false,
      default: () => []
    }, // 部屋タイプ
    mealCondition: {
      type: Array,
      required: false,
      default: () => []
    }, // 食事条件
    roomCondition: {
      type: Array,
      required: false,
      default: () => []
    }, // 部屋のこだわり
    serviceEquip: {
      type: Array,
      required: false,
      default: () => []
    }, // 設備・サービス
    usageMethod: {
      type: Array,
      required: false,
      default: () => []
    }, // 利用方法
    planByCompany: {
      type: Array,
      required: false,
      default: () => []
    }, // 提供会社
    isVisible: {
      type: Boolean,
      required: false,
      default: false
    }, // モーダルの表示状態
  },
  data() {
    return {
      selectedFacility: this.facility,            // 操作中の施設タイプ
      selectedRoomType: this.roomType,            // 操作中の部屋タイプ
      selectedMealCondition: this.mealCondition,  // 操作中の食事条件
      selectedRoomCondition: this.roomCondition,  // 操作中の部屋のこだわり
      selectedServiceEquip: this.serviceEquip,    // 操作中の接尾・サービス
      selectedUsageMethod: this.usageMethod,      // 操作中の利用方法
      selectedPlanByCompany: this.planByCompany,  // 操作中の提供会社
    }
  },
  computed: {
    /**
     * disableRakutenを計算する
     */
    disableRakuten() {
      const companyCd = sessionStorage.getItem('companyCd') || ''
      return companyCd !== '' &&
        process.env.VUE_APP_DISABLE_RAKUTEN_TRAVEL
          ?.split(',')
          .includes(companyCd)
    },
    /**
     * isRakutenをフィルタリングしたselectedPlanByCompany
     */
    filteredSelectedPlanByCompany() {
      if (this.disableRakuten) {
        return this.selectedPlanByCompany.filter(item => item.id !== 'isRakuten')
      }
      return this.selectedPlanByCompany
    }
  },
  watch: {
    facility(newList) {
      this.selectedFacility = newList
    },
    roomType(newList) {
      this.selectedRoomType = newList
    },
    mealCondition(newList) {
      this.selectedMealCondition = newList
    },
    roomCondition(newList) {
      this.selectedRoomCondition = newList
    },
    serviceEquip(newList) {
      this.selectedServiceEquip = newList
    },
    usageMethod(newList) {
      this.selectedUsageMethod = newList
    },
    planByCompany(newList) {
      this.selectedPlanByCompany = newList
    },
  },
  methods: {
    /**
     * 現在の入力状況を反映し、emitする
     */
    inputed() {
      // disableRakutenがtrueの場合はisRakutenをフィルタリング
      let planByCompany = this.selectedPlanByCompany
      if (this.disableRakuten) {
        planByCompany = this.selectedPlanByCompany.filter(item => item.id !== 'isRakuten')
      }

      const list = {
        facility: this.selectedFacility,
        roomType: this.selectedRoomType,
        mealCondition: this.selectedMealCondition,
        roomCondition: this.selectedRoomCondition,
        serviceEquip: this.selectedServiceEquip,
        usageMethod: this.selectedUsageMethod,
        planByCompany: planByCompany
      }

      this.$emit('inputed', list)
    },
    /**
     * 指定されたタイプでselectedのリストを更新する
     */
    setList(item, type) {
      this[type] = this[type].map(d => {
        if (d.id === item.id) {
          return {
            ...d,
            checked: !item.checked
          }
        }
        return d
      })

      this.inputed()
    },
    /**
     * リセットボタンが押されたら全てのチェックを外す
     */
    resetList() {
      const selectedList = [
        'selectedFacility',
        'selectedRoomType',
        'selectedMealCondition',
        'selectedRoomCondition',
        'selectedServiceEquip',
        'selectedUsageMethod',
        'selectedPlanByCompany'
      ]

      selectedList.forEach(id => {
        this[id] = this[id].map(d => {
          return { ...d, checked: false }
        })
      })

      this.inputed()
    },
    /**
     * 決定ボタンが押されたら
     */
    emitInputed() {
      this.inputed()
      this.emitClosed()
    },
    /**
     * 閉じるボタン、背景がクリックされたら
     */
    emitClosed() {
      this.$emit('closed')
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/mixins.scss';
@import '@/assets/scss/variables.scss';

.modal-special-conditions {
  align-items: center;
  background-color: rgba($black, 0.5);
  cursor: pointer;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  padding: 1rem;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 9999;

  &__text {
    flex-shrink: 0;
    width: 4rem;

    @include sp {
      font-size: 0.875rem;
      margin-bottom: 0.5rem;
    }
  }

  &__buttons {
    align-items: center;
    background-color: $white;
    display: flex;
    filter: drop-shadow(0 2px 3px rgba($black, .5));
    gap: 1rem;
    height: 5rem;
    justify-content: center;
    padding: 0 1rem;
  }

  &__button {
    background-color: $white;
    cursor: pointer;
    display: block;
    font-family: inherit;
    padding: 0 0.5rem;
    position: relative;
    text-align: left;
    width: 100%;

    @include hover {
      opacity: .8;
    }

    &.--close {
      background-color: transparent;
      cursor: pointer;
      height: 3rem;
      position: absolute;
      right: 0;
      top: 0;
      width: 3rem;

      &::before,
      &::after {
        background-color: $black;
        content: '';
        display: block;
        height: 1px;
        pointer-events: none;
        position: absolute;
        right: 0.75rem;
        top: 50%;
        width: 1.5rem;
      }

      &::before {
        transform: rotateZ(45deg);
      }

      &::after {
        transform: rotateZ(135deg);
      }
    }

    &.--reset {
      border: 1px solid $cool-gray-4;
      border-radius: 0.25rem;
      height: 3rem;
      line-height: 3rem;
      max-width: 10rem;
      text-align: center;
    }

    &.--dicision {
      background-color: $black;
      border-radius: 0.25rem;
      color: $white;
      font-weight: bold;
      height: 3rem;
      line-height: 3rem;
      max-width: 10rem;
      text-align: center;
    }
  }

  &__modal {
    border-radius: .25rem;
    cursor: default;
    height: 80vh;
    max-width: 40rem;
    overflow: hidden;
    width: 100%;
  }

  &__body {
    background-color: $white;
    height: calc(100% - 8rem);
    overflow-y: scroll;
  }

  &__heading {
    background-color: $cool-gray-4;
    font-size: 1rem;
    font-weight: bold;
    height: 3rem;
    line-height: 3rem;
    position: relative;
    padding: 0 1rem;
    width: 100%;

    &.--small {
      background-color: $cool-gray-5;
      font-size: .875rem;
      height: 2.5rem;
      line-height: 2.5rem;
    }
  }

  &__list {
    border-left: 1px solid $cool-gray-5;
    display: flex;
    flex-wrap: wrap;
  }

  &__item {
    border-color: $cool-gray-5;
    border-style: solid;
    border-width: 0 1px 1px 0;
    flex-shrink: 0;
    // padding: .75rem 1rem;
    width: calc(100% / 3);

    @include sp {
      width: 50%;
    }
  }

  &__checkbox {
    @include sp {
      font-size: .75rem;
    }
  }
}

</style>